<template>
	<div class="input file" :class="{ 'input-error': errors[id] }">
		<label :for="id" v-if="name">{{ name }}</label>
		<input 
			:id="id"
			type="file"
			ref="file"
			v-on:change="handleFileUpload()"
			accept="image/png, image/jpeg, image/jpg, image/gif"
			/>
		<span class="error-message">{{ errors[id] }}</span>
	</div>
</template>

<script>
	import API from './../../lib/api'

	export default {
		props: ['id', 'name', 'form', 'errors'],
		methods: {
			handleFileUpload() {
				if(this.$refs.file.files.length) {
					const api = new API(1, 'upload/image')
					let formData = new FormData()

					formData.append('file', this.$refs.file.files[0])
					this.$store.commit('app/setLoading', true)
					api.post(formData).then(image => {
						this.form[this.id] = image.file
						this.$store.commit('app/setLoading', false)
					}).catch(err => {
						this.$store.commit('app/setLoading', false)
						this.$store.dispatch('app/addAlert', {
							type: 'error',
							message: 'Error uploading your image, please try later',
							timeout: 3000
						})
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Form/ImageUpload.vue